// extracted by mini-css-extract-plugin
export var standaloneTable = "_1v-0";
export var standaloneTableWithBodyFill = "_1v-1";
export var withExtraHeader = "_1v-2";